import React, { FC } from 'react';
import classNames from 'classnames';
import CellValue from '@app/shared/components/cell-value/CellValue';
import { Alignment } from '@app/shared/enums/alignment.enum';
import { amountRules } from '@app/shared/components/cell-value/CellValueConfigurations';
import styles from '../../opm-summary-waterfall-erf.module.scss';

interface TrancheConditionsCellProps {
  conditionIndex: number;
  index: number;
  trancheIndex: number;
  includeRightBorder: boolean;
  conditionReference?: string;
  sponsorHurdleLabel?: string;
  onHandleClick?: (conditionReference: string, title: string) => void;
  value: number;
}

const TrancheConditionsCell: FC<TrancheConditionsCellProps> = ({
  conditionIndex,
  index,
  trancheIndex,
  includeRightBorder,
  conditionReference,
  sponsorHurdleLabel,
  onHandleClick,
  value,
}) => (
  <td
    className={classNames({
      [styles['border-right']]: includeRightBorder,
      [styles['clickable-cell']]: conditionReference,
    })}
    data-testid={`condition${conditionIndex + 1}-tranche${trancheIndex + 1}-simulation-${index}`}
    onClick={
      conditionReference && sponsorHurdleLabel && onHandleClick
        ? () => onHandleClick(conditionReference, sponsorHurdleLabel)
        : undefined
    }>
    <CellValue value={value} alignment={Alignment.Right} {...amountRules} />
  </td>
);

export default React.memo(TrancheConditionsCell);
